<template>
    <div class="td-top-search-wrap" v-if="isSearchOpen">
        <div class="td-top-search-mask" v-on:click="onMaskClick">
            <div class="td-top-search">
                <div class="td-top-container" @keyup="onInputKeyUp" @keydown="onSearchInputKeyUp">
                    <div class="td-top-search-box-wrap">
                        <i class="fa fa-search  td-search-box-icon"></i>
                        <input id="search-input" v-model="userSearchQuery" type="text"
                               :placeholder="$__('Search by name, SSI, team or reason')"
                               class="form-control td-search-form-control" ref="userSearchQueryRef">
                    </div>

                    <div class="td-tops-results">

                        <!-- is loading is false, and we have results -->
                        <div v-if="resultsLength > 0 && isLoading === false" v-for="(searchResultSection,index) in searchResultsSections"
                             class="td-top-search-section-wrap">
                            <!-- users -->
                            <div class="td-search-result-section td-search-result-section-users"
                                 v-if="index === 'users' && searchResultSection.results.length > 0">
                                <div class="td-search-section-title">{{ $__(searchResultSection.section_title) }}:</div>

                                <div class="search-results">
                                    <div
                                        :class="{'row-selected': resultsSection === 'users' && resultsIndex === iindex }"
                                        class="search-result-row"
                                        v-for="(sectionResults,iindex) in searchResultSection.results">
                                        <a @click="onLinkClick" :href=sectionResults.link
                                           :title="sectionResults.is_enabled === '0' ? $__('The employee has his contract terminated') : ''">
                                            <img class="td-user-image" :src="getAvatarUrl(sectionResults.avatar_url)"/>
                                            <div class="td-result-meta-info">
                                                <span
                                                    :class="{'results-title': true, 'td-disabled-user': sectionResults.is_enabled === '0'}"
                                                    v-html="sectionResults.name_html"></span>
                                                <span class="results-sub-title">
                                                    -
                                                    <span v-if="$store.getters.isAdmin" v-html="sectionResults.cnp_html"></span>
                                                    <span>{{ sectionResults.team }}</span>


                                                    <span v-if="sectionResults.reports_excluded_view === true"
                                                          class="top-search-dashlight"
                                                          :title="$__('Employee is hidden from all the reports due to permission settings. Click here to change them.')">
                                                        <i class="fa fa-eye-slash"></i>
                                                    </span>
                                                </span>

                                            </div>

                                        </a>
                                    </div>
                                </div>
                                <router-link @click.native="onLinkClick"
                                             v-if="searchResultSection.results.length > 0 && $store.getters.isTeamLederOrAdmin === true"
                                             :to="{ name: 'usersIndex', params: { user: userSearchQuery, teamIds: 'All', selectedUsers: 'None'} }">
                                    {{ $__('Show more employees') }}
                                </router-link>
                            </div>

                            <!-- teams -->
                            <div class="td-search-result-section"
                                 v-if="index === 'teams' && searchResultSection.results.length > 0">
                                <div class="td-search-section-title">{{ $__(searchResultSection.section_title) }}:</div>

                                <div class="search-results">
                                    <div
                                        :class="{'row-selected': resultsSection === 'teams' && resultsIndex === iindex }"
                                        class="search-result-row"
                                        v-for="(sectionResults,iindex) in searchResultSection.results">
                                        <a @click="onLinkClick" :href=sectionResults.link><img class="td-team-image"
                                                                                               src="../../assets/team.png">
                                            <span class="results-title" v-html="sectionResults.html"></span>&nbsp;&nbsp;&nbsp;<span
                                                class="results-sub-title">{{ sectionResults.employees }} {{ $__('employees') }}</span></a>
                                    </div>
                                </div>


                                <router-link @click.native="onLinkClick" exact
                                             :to="{ name: 'teamsListRoute', params: {team:userSearchQuery} }">
                                    {{ $__('Show all teams') }}
                                </router-link>

                            </div>

                            <!-- events -->
                            <div class="td-search-result-section"
                                 v-if="index === 'events' && searchResultSection.results.length > 0">
                                <div class="td-search-section-title">{{ $__(searchResultSection.section_title) }}:</div>

                                <div class="search-results">
                                    <div
                                        :class="{'row-selected': resultsSection === 'events' && resultsIndex === iindex }"
                                        class="search-result-row"
                                        v-for="(sectionResults, iindex) in searchResultSection.results">
                                        <a @click="onLinkClick" :href=sectionResults.link><span
                                            class="results-user-full-name">{{ $__(sectionResults.user_full_name) }}</span>
                                            - <span class="results-title" v-html="sectionResults.html"></span>&nbsp;&nbsp;&nbsp;<span
                                                class="results-sub-title">{{ $__(sectionResults.type) }} - {{ sectionResults.start }} - {{ sectionResults.end }}</span></a>
                                    </div>
                                </div>

                                <router-link
                                    @click.native="onLinkClick" v-if="searchResultSection.results.length > 0"
                                    :to="{
                                      name: 'activityEventsRoute',
                                      params: {
                                        page: '1',
                                        users: 'All',
                                        teams: 'All',
                                        eventTypes: 'All',
                                        leaveDaysTypes: 'All',
                                        status: 'reason',
                                        dateInterval: 'All',
                                        reason: userSearchQuery,
                                      }
                                  }">
                                    {{ $__('Show more events') }}
                                </router-link>
                            </div>

                            <!-- events -->
                            <div class="td-search-result-section"
                                 v-if="index === 'articles' && searchResultSection.results.length > 0">
                                <div class="td-search-section-title">{{ $__(searchResultSection.section_title) }}:</div>

                                <div class="search-results">
                                    <div
                                        :class="{'row-selected': resultsSection === 'articles' && resultsIndex === iindex }"
                                        class="search-result-row"
                                        v-for="(sectionResults, iindex) in searchResultSection.results">
                                        <a :href=sectionResults.link><span class="results-title"
                                                                           v-html="sectionResults.title"></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- is loading is false, and we don't have results -->
                        <div v-if="resultsLength === 0 && userSearchQuery !== '' && isLoading === false" class="">
                            <div class="no-search-results">
                                {{ $__('There are no results for your search!') }}
                            </div>
                        </div>

                        <!-- is loading is true -->
                        <div v-if="isLoading === true">
                            <div class="no-search-results">
                                {{$__('Loading')}}<span class="loader__dot">.</span><span class="loader__dot">.</span><span class="loader__dot">.</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import tdApi from '../../tdApi.js';
    import tdDeploy from '../../tdDeploy.js';

    export default {

        props: {
            isSearchOpen: false
        },

        data () {
            return this.initialDataState();
        },


        created() {
            let vm = this;
            window.addEventListener('keyup', function(event) {
                if (vm.isSearchOpen === true && event.key === 'Escape') {
                    vm.$emit('searchClose');
                }
            });
        },


        methods: {
            mysql_real_escape_string(str) {
              if (typeof str != 'string')
                return str;

              str = str.trim();
              return str.replace(/[\0\x08\x09\x1a\n\r"'\\\%]/g, function (char) {
                switch (char) {
                  case "\0":
                    return "\\0";
                  case "\x08":
                    return "\\b";
                  case "\x09":
                    return "\\t";
                  case "\x1a":
                    return "\\z";
                  case "\n":
                    return "\\n";
                  case "\r":
                    return "\\r";
                  case "\"":
                  case "'":
                  case "\\":
                  case "%":
                    return "\\"+char; // prepends a backslash to backslash, percent,
                                      // and double/single quotes
                }
              });
            },
            initialDataState() {
                // adding new item - blank initial state
                let newInitialState = {
                    userSearchQuery: "",
                    searchResultsSections: {},
                    resultsSection: 'users',
                    resultsIndex: -1,

                    // used to identify the last requests / responses from the search box
                    apiCurRequestsNumber:0,
                    isLoading: false

                };

                return newInitialState;
            },

            getAvatarUrl(avatarUrl) {
                return tdDeploy.apiThumbUrl + avatarUrl;
            },

            onLinkClick(){
                this.$emit('searchClose');
            },

            onMaskClick(event) {
                if (event.target.className === 'td-top-search-mask' || event.target.className === 'td-top-search') {
                    this.$emit('searchClose');

                }
            },

            moveIndex(value) {
                let vm = this;
                let index = vm.resultsIndex;
                let section = vm.resultsSection;
                index = index + value;

                if(index > vm.searchResultsSections[section].results.length-1){
                    if(section === 'users'){
                        index = 0;
                        section = 'teams';
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'events';
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'articles';
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'users';
                                    index = 0;
                                }
                            }
                        }
                    }else if( section === 'teams'){
                        index = 0;
                        section = 'events';
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'articles';
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'users';
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'teams';
                                    index = 0;
                                }
                            }
                        }
                    }else if( section === 'events'){
                        index = 0;
                        section = 'articles';
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'users';
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'teams';
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'events';
                                    index = 0;
                                }
                            }
                        }
                    }else {
                        index = 0;
                        section = 'users';
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'teams';
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'events';
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'articles';
                                    index = 0;
                                }
                            }
                        }
                    }
                }else if(index < 0){
                    if(section === 'articles'){
                        section = 'events';
                        index = vm.searchResultsSections[section].results.length-1;
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'teams';
                            index = vm.searchResultsSections[section].results.length-1;
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'users';
                                index = vm.searchResultsSections[section].results.length-1;
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'articles';
                                    index = vm.searchResultsSections[section].results.length-1;
                                }
                            }
                        }
                    }else if(section === 'events'){
                        section = 'teams';
                        index = vm.searchResultsSections[section].results.length-1;
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'users';
                            index = vm.searchResultsSections[section].results.length-1;
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'articles';
                                index = vm.searchResultsSections[section].results.length-1;
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'events';
                                    index = vm.searchResultsSections[section].results.length-1;
                                }
                            }
                        }
                    }else if( section === 'teams'){
                        section = 'users';
                        index = vm.searchResultsSections[section].results.length-1;
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'articles';
                            index = vm.searchResultsSections[section].results.length-1;
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'events';
                                index = vm.searchResultsSections[section].results.length-1;
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'teams';
                                    index = vm.searchResultsSections[section].results.length-1;
                                }
                            }
                        }
                    }else{
                        section = 'articles';
                        index = vm.searchResultsSections[section].results.length-1;
                        if(vm.searchResultsSections[section].results.length === 0) {
                            section = 'events';
                            index = vm.searchResultsSections[section].results.length-1;
                            if(vm.searchResultsSections[section].results.length === 0) {
                                section = 'teams';
                                index = vm.searchResultsSections[section].results.length-1;
                                if(vm.searchResultsSections[section].results.length === 0) {
                                    section = 'users';
                                    index = vm.searchResultsSections[section].results.length-1;
                                }
                            }
                        }
                    }
                }
                vm.resultsIndex = index;
                vm.resultsSection = section;
            },


            onSearchInputKeyUp: function(event) {
                let vm = this;
                if (event.code === 'ArrowUp') {
                    event.preventDefault();
                    vm.moveIndex(-1);
                } else if (event.code === 'ArrowDown') {
                    event.preventDefault();
                    vm.moveIndex(1);
                } else if (event.code !== 'ArrowRight' && event.code !== 'ArrowLeft') {
                    vm.isLoading = true;
                }

            },

            onInputKeyUp : function (event) {


                let vm = this;


                //console.log(event.code);

                if(event.code === 'Enter') {
                    if(vm.resultsIndex >= 0) {
                        let url = vm.searchResultsSections[vm.resultsSection].results[vm.resultsIndex].link;
                        if (!vm.searchResultsSections[vm.resultsSection].results[vm.resultsIndex].link.includes('http')) {
                            // the push requires a link without # but the mouse click requires with #
                            url = url.replace('#/', '/');
                            vm.$router.push(url);
                            vm.$emit('searchClose');
                        }else{
                            window.open(url, "_blank");
                        }
                    }
                } else if(event.code !== 'ArrowUp' && event.code !== 'ArrowDown' && event.code !== 'ArrowRight' && event.code !== 'ArrowLeft') {
                    let topSearchApi = new tdApi('search/top_search');


                    // some routes don't have a name!
                    let curRouteName = '';
                    if (vm.$router.currentRoute.name !== undefined) {
                        curRouteName = vm.$router.currentRoute.name;
                    }




                    vm.apiCurRequestsNumber++;
                    topSearchApi.run({
                            'post': {
                                query: vm.mysql_real_escape_string(vm.userSearchQuery),
                                cur_route_name: curRouteName,
                                cur_route_path: vm.$router.currentRoute.path,
                                cur_request_number: vm.apiCurRequestsNumber
                                //cur_route_params: vm.$router.currentRoute.params
                            },
                            'done': function (apiReply) {

                                // if it's an older request skip it.
                                if (parseInt(apiReply.cur_request_number) !== parseInt(vm.apiCurRequestsNumber)) {
                                    //console.log('late request ... ignored',vm.apiCurRequestsNumber, apiReply.cur_request_number , apiReply);
                                    return;
                                }
                                vm.searchResultsSections = apiReply.search_results_sections;
                                vm.resultsSection = 'users';
                                vm.resultsIndex = -1;
                                vm.isLoading = false;
                            }.bind(this)
                        }
                    );
                }

            },

        },

      computed: {
        resultsLength() {
          let vm = this;
          let rLength = 0;
          if(vm.searchResultsSections.users !== undefined){
            if(vm.searchResultsSections.users.results !== undefined) {
              rLength = rLength + vm.searchResultsSections.users.results.length;
            }
          }
          if(vm.searchResultsSections.teams !== undefined){
            if(vm.searchResultsSections.teams.results !== undefined) {
              rLength = rLength + vm.searchResultsSections.teams.results.length;
            }
          }
          if(vm.searchResultsSections.events !== undefined){
            if(vm.searchResultsSections.events.results !== undefined) {
              rLength = rLength + vm.searchResultsSections.events.results.length;
            }
          }
            if(vm.searchResultsSections.articles !== undefined){
                if(vm.searchResultsSections.articles.results !== undefined) {
                    rLength = rLength + vm.searchResultsSections.articles.results.length;
                }
            }
          return rLength;
        },
      },

        watch: {
            'isSearchOpen': function (isSearchOpen) {
                if (isSearchOpen === true) {
                    // On show

                    // focus on the element based on the ref attribute (strange vue shit)
                    let vm = this;
                    this.$nextTick(function () {
                        // register a nextTick callback to make sure that the element is rendered when we try to focus
                        if (vm.$refs["userSearchQueryRef"] !== undefined) {
                            if (Array.isArray(vm.$refs["userSearchQueryRef"])) {
                                //on v-for we get an array, focus on 1st element
                                vm.$refs["userSearchQueryRef"][0].focus();
                            } else {
                                vm.$refs["userSearchQueryRef"].focus();
                            }
                        }

                    });


                } else {
                    // On hide

                    // clear all the state stored in the dialog and load the initial data
                    Object.assign(this, this.initialDataState());
                }
            }
        }

    }
</script>

<style lang="scss">
    .td-top-search-wrap {

        .td-disabled-user {
            text-decoration: line-through;
        }

        .row-selected {
          background-color: rgba(186, 210, 238, 0.47);
        }

        mark {
          padding: 0;
          font-weight: bold;
          background-color: inherit;
        }

        .search-results {
            margin: 6px 0;

            a {
                color: #656565;
                display: block;
                padding: 5px 24px;
                &:hover {
                    mark {
                        color: #395fc5;
                    }
                    color: #395fc5;
                }
            }
        }

        .search-result-row {
            margin-bottom: 1px;
            position: relative;
            //&:hover {
            //    background-color: rgba(186, 210, 238, 0.47);
            //}
            //padding: 5px 24px;
        }

        .td-result-meta-info {
            margin-left: 35px;
            min-height: 25px;
        }

        .top-search-dashlight {
            color:red;
            margin-left: 3px;
        }
        .results-sub-title {
            font-size: 11px;
            position: relative;
            top:2px;
            color: #808080;

        }

        .results-title {
            margin-left: 7px;
            position: relative;
            top:2px;
        }

        .td-top-search-mask {
            position: fixed;
            z-index: 9998;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(255, 255, 255, 0.3);
            display: table;
            transition: opacity .3s ease;
        }

        .td-top-container {
            position: relative;
            width: 520px;
            max-width: 100vw;
            max-height: 85vh;
            margin: 0 auto;
            padding: 24px 0;
            background-color: #fff;
            border-radius: 4px;
            box-shadow: 0 10px 70px 0 rgba(67,120,180,.22), 0 15px 105px 0 rgba(67,120,180,.22);
            transition: all 0.2s ease;
            font-family: 'Open Sans', Arial, sans-serif;
            overflow: auto;

            border: 1px solid #bad2ee;

        }



        .td-top-search {
            z-index: 999999;
            margin-top: 4%;
        }

        .td-user-image {
            width: 25px;
            height: 25px;
            border-radius: 100px;
            border: 2px solid #aac1ff;
            cursor: pointer;

            &:hover {
              border: 2px solid rgba(255, 69, 0, 0.51);
            }
            position: absolute;
            top:50%;
            transform: translateY(-50%)
        }

        .td-team-image {
          width: 25px;
          height: 25px;
          border: none;
          cursor: pointer;
        }


        .td-search-form-control {
            height: 28px;
            padding: 5px 10px 5px 29px;
            font-size: 13px;
            line-height: 1;
            color: #444;
            border: 1px solid #c0d3e6;
            border-radius: 0;
            box-shadow: none;
        }


        .td-top-search-box-wrap {
            margin: 0 24px;
            position: relative;
        }

        .td-search-box-icon{
            position: absolute;
            top:8px;
            left:10px;
            color:#c0d3e6;
        }


        // first result + last result
        .td-top-search-section-wrap {

            &:first-child {
                padding-top: 10px;
            }

            &:last-child {
                .td-search-result-section {

                    border-bottom: none;
                    padding-bottom: 0;

                    .search-results {
                        margin-bottom: 0;
                    }
                }
            }


        }



        // search sections
        .td-search-result-section {
            padding: 13px 0 ;
            border-bottom: 1px solid #f3f7fc;
            > a {
                padding: 0 24px;
            }
        }

        .td-search-result-section-users {
            .results-title {
                margin-left: 0;
            }
        }


        .td-search-section-title {
            color:black;
            font-size:13px;
            font-weight: bold;
            padding: 0 24px;
        }

        .no-search-results {
            padding: 18px 24px 0 24px;
        }


        @keyframes blink {50% { color: transparent }}
        .loader__dot { animation: 1s blink infinite }
        .loader__dot:nth-child(2) { animation-delay: 250ms }
        .loader__dot:nth-child(3) { animation-delay: 500ms }
    }


</style>



// WEBPACK FOOTER //
// src/components/topSearch/topSearch.vue